import React from 'react';
import { HyperdbForm } from '../../../hyperdb';
import { Form } from '../components';

export default HyperdbForm(Form, {
  namespace: 'user',
  mountedUrl: '/users',
  titleNew: 'Create new user',
  titleEdit: 'Edit user',
  displayName: (object) => object.name,
  checkIsValid: (props) => {
    const user = props.objectData;
    const passwordValid = !user.id ? !!user.password && user.password === user.confirm_password : true;
    return !!user.group && !!user.name && !!user.email && !!user.login && passwordValid;
  },
  onSubmit: (props) => {
    const { confirm_password, group, ...userData } = props.objectData;
    let error = null;
    if (userData.password) {
      if (userData.password !== confirm_password) error = 'Confirm password is different';
    } else {
      delete userData.password;
    }
    if (error) return props.api.user.setData({ errorMessage: error });
    userData.groups = [group];
    return !userData.id
      ? props.api.user.submitCreateForm(userData)
      : props.api.user.submitEditForm({ id: userData.id, objectData: userData });
  },
});



// WEBPACK FOOTER //
// ./src/frontend/modules/users/containers/Form.jsx